import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgExploreNoResults = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 390,
	height: 459,
	viewBox: "0 0 390 459",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#filter0_ddddd_12603_26629)",
			children: /* @__PURE__ */ _jsx("rect", {
				x: 122,
				y: 18,
				width: 240,
				height: 240,
				rx: 43.5817,
				fill: "#0D26BB"
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M195.715 209.454H173.516V227.108H195.715V209.454Z",
			fill: "url(#paint0_linear_12603_26629)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M173.517 203.894C178.646 203.894 182.803 208.051 182.803 213.18V258.106H164.23V213.18C164.23 208.051 168.388 203.894 173.517 203.894Z",
			fill: "url(#paint1_linear_12603_26629)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M288.594 227.108H310.793V209.454H288.594V227.108Z",
			fill: "url(#paint2_linear_12603_26629)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M320.078 258.104H301.506V213.177C301.506 208.053 305.665 203.891 310.792 203.891C315.916 203.891 320.078 208.051 320.078 213.177V258.104Z",
			fill: "url(#paint3_linear_12603_26629)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M251.44 162.326H232.867V186.78H251.44V162.326Z",
			fill: "url(#paint4_linear_12603_26629)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M235.346 157.678C270.091 166.988 301.307 163.157 305.068 149.121C308.829 135.085 283.711 116.16 248.965 106.849C214.22 97.5395 183.004 101.37 179.243 115.406C175.482 129.442 200.6 148.368 235.346 157.678Z",
			fill: "url(#paint5_linear_12603_26629)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M230.697 175.018C259.857 182.832 288.625 170.023 294.952 146.41C301.279 122.797 282.769 97.3212 253.609 89.5078C224.449 81.6944 195.681 94.5025 189.354 118.116C183.027 141.729 201.537 167.205 230.697 175.018Z",
			fill: "url(#paint6_linear_12603_26629)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M271.534 124.244L221.412 110.813C213.171 108.605 204.621 113.541 202.413 121.782C200.205 130.023 205.141 138.573 213.382 140.781L263.504 154.211C271.745 156.419 280.295 151.483 282.503 143.242C284.711 135.002 279.775 126.452 271.534 124.244Z",
			fill: "url(#paint7_linear_12603_26629)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M220.629 133.953C224.358 133.462 226.982 130.041 226.491 126.313C226.001 122.584 222.58 119.959 218.851 120.45C215.122 120.941 212.498 124.362 212.988 128.09C213.479 131.819 216.9 134.444 220.629 133.953Z",
			fill: "#84A5FB"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M273.613 143.254C275.395 139.942 274.154 135.812 270.842 134.03C267.53 132.248 263.401 133.489 261.619 136.801C259.837 140.113 261.078 144.242 264.39 146.024C267.702 147.806 271.831 146.566 273.613 143.254Z",
			fill: "#84A5FB"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M242.154 183.047C211.965 183.047 187.492 197.123 187.492 214.487V258.109H296.817V214.487C296.817 197.123 272.344 183.047 242.156 183.047H242.154Z",
			fill: "url(#paint8_linear_12603_26629)"
		}),
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#filter1_ddddd_12603_26629)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M197.991 37H114.009C105.754 37 99 41.939 99 47.9767V84.0309C99 90.0685 105.754 95.0075 114.009 95.0075H164.155C164.416 95.0075 164.666 95.1095 164.853 95.2916L176.187 106.344C176.82 106.962 177.885 106.513 177.885 105.628V96.0075C177.885 95.4552 178.333 95.0075 178.885 95.0075H197.991C206.246 95.0075 213 90.0685 213 84.0309V47.9767C213 41.939 206.246 37 197.991 37Z",
				fill: "#EDF4FF"
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M120.76 59.722H116.998V70H114.37V59.722H110.572V57.328H120.76V59.722ZM121.503 60.838H124.023V62.71C124.191 62.098 124.503 61.6 124.959 61.216C125.427 60.82 125.961 60.622 126.561 60.622C127.077 60.622 127.545 60.736 127.965 60.964V63.358C127.533 63.094 127.017 62.962 126.417 62.962C125.733 62.962 125.163 63.232 124.707 63.772C124.263 64.3 124.035 65.008 124.023 65.896V70H121.503V60.838ZM132.638 69.658L128.732 60.838H131.576L133.844 66.652L136.22 60.838H138.974L133.106 74.14H130.802L132.638 69.658ZM149.784 64.582C149.784 64.018 149.58 63.574 149.172 63.25C148.764 62.926 148.224 62.764 147.552 62.764C146.544 62.764 145.62 63.118 144.78 63.826V61.594C145.2 61.27 145.68 61.03 146.22 60.874C146.772 60.706 147.336 60.622 147.912 60.622C148.776 60.622 149.538 60.784 150.198 61.108C150.87 61.432 151.386 61.882 151.746 62.458C152.118 63.034 152.304 63.694 152.304 64.438V70H149.784V68.83C149.58 69.25 149.256 69.586 148.812 69.838C148.368 70.09 147.87 70.216 147.318 70.216C146.73 70.216 146.202 70.09 145.734 69.838C145.266 69.574 144.9 69.22 144.636 68.776C144.372 68.32 144.24 67.816 144.24 67.264C144.24 66.7 144.378 66.196 144.654 65.752C144.942 65.308 145.332 64.966 145.824 64.726C146.328 64.474 146.898 64.348 147.534 64.348C147.954 64.348 148.362 64.408 148.758 64.528C149.166 64.648 149.508 64.81 149.784 65.014V64.582ZM146.688 67.192C146.688 67.516 146.802 67.774 147.03 67.966C147.27 68.158 147.582 68.254 147.966 68.254C148.47 68.254 148.89 68.11 149.226 67.822C149.574 67.522 149.76 67.126 149.784 66.634V66.616C149.244 66.268 148.674 66.094 148.074 66.094C147.654 66.094 147.318 66.196 147.066 66.4C146.814 66.604 146.688 66.868 146.688 67.192ZM158.769 69.874C157.953 69.874 157.209 69.676 156.537 69.28C155.877 68.872 155.349 68.32 154.953 67.624C154.569 66.916 154.377 66.124 154.377 65.248C154.377 64.372 154.569 63.586 154.953 62.89C155.349 62.182 155.877 61.63 156.537 61.234C157.209 60.826 157.953 60.622 158.769 60.622C159.429 60.622 160.005 60.76 160.497 61.036C161.001 61.312 161.391 61.696 161.667 62.188V60.838H164.187V69.244C164.187 70.18 163.977 70.99 163.557 71.674C163.137 72.358 162.555 72.88 161.811 73.24C161.067 73.6 160.233 73.78 159.309 73.78C158.685 73.78 158.037 73.69 157.365 73.51C156.705 73.342 156.111 73.096 155.583 72.772V70.648C156.087 70.984 156.627 71.242 157.203 71.422C157.791 71.602 158.349 71.692 158.877 71.692C159.693 71.692 160.359 71.47 160.875 71.026C161.403 70.582 161.667 69.946 161.667 69.118V68.308C161.403 68.812 161.019 69.202 160.515 69.478C160.011 69.742 159.429 69.874 158.769 69.874ZM156.933 65.248C156.933 65.932 157.161 66.508 157.617 66.976C158.073 67.432 158.637 67.66 159.309 67.66C159.981 67.66 160.539 67.432 160.983 66.976C161.439 66.52 161.667 65.944 161.667 65.248C161.667 64.552 161.439 63.976 160.983 63.52C160.539 63.064 159.981 62.836 159.309 62.836C158.637 62.836 158.073 63.07 157.617 63.538C157.161 63.994 156.933 64.564 156.933 65.248ZM171.958 64.582C171.958 64.018 171.754 63.574 171.346 63.25C170.938 62.926 170.398 62.764 169.726 62.764C168.718 62.764 167.794 63.118 166.954 63.826V61.594C167.374 61.27 167.854 61.03 168.394 60.874C168.946 60.706 169.51 60.622 170.086 60.622C170.95 60.622 171.712 60.784 172.372 61.108C173.044 61.432 173.56 61.882 173.92 62.458C174.292 63.034 174.478 63.694 174.478 64.438V70H171.958V68.83C171.754 69.25 171.43 69.586 170.986 69.838C170.542 70.09 170.044 70.216 169.492 70.216C168.904 70.216 168.376 70.09 167.908 69.838C167.44 69.574 167.074 69.22 166.81 68.776C166.546 68.32 166.414 67.816 166.414 67.264C166.414 66.7 166.552 66.196 166.828 65.752C167.116 65.308 167.506 64.966 167.998 64.726C168.502 64.474 169.072 64.348 169.708 64.348C170.128 64.348 170.536 64.408 170.932 64.528C171.34 64.648 171.682 64.81 171.958 65.014V64.582ZM168.862 67.192C168.862 67.516 168.976 67.774 169.204 67.966C169.444 68.158 169.756 68.254 170.14 68.254C170.644 68.254 171.064 68.11 171.4 67.822C171.748 67.522 171.934 67.126 171.958 66.634V66.616C171.418 66.268 170.848 66.094 170.248 66.094C169.828 66.094 169.492 66.196 169.24 66.4C168.988 66.604 168.862 66.868 168.862 67.192ZM179.611 70H177.091V60.838H179.611V70ZM178.333 56.662C178.765 56.662 179.131 56.818 179.431 57.13C179.743 57.43 179.899 57.79 179.899 58.21C179.899 58.63 179.743 58.99 179.431 59.29C179.131 59.59 178.765 59.74 178.333 59.74C177.889 59.74 177.517 59.59 177.217 59.29C176.929 58.99 176.785 58.63 176.785 58.21C176.785 57.79 176.929 57.43 177.217 57.13C177.517 56.818 177.889 56.662 178.333 56.662ZM184.862 62.188C185.15 61.684 185.528 61.3 185.996 61.036C186.464 60.76 186.992 60.622 187.58 60.622C188.672 60.622 189.542 60.988 190.19 61.72C190.85 62.44 191.18 63.424 191.18 64.672V70H188.66V65.014C188.66 64.39 188.486 63.886 188.138 63.502C187.802 63.118 187.352 62.926 186.788 62.926C186.224 62.926 185.762 63.142 185.402 63.574C185.042 64.006 184.862 64.552 184.862 65.212V70H182.342V60.838H184.862V62.188ZM196.29 57.202C197.406 57.202 198.324 57.502 199.044 58.102C199.776 58.69 200.142 59.548 200.142 60.676C200.142 61.192 200.052 61.648 199.872 62.044C199.704 62.428 199.494 62.752 199.242 63.016C198.99 63.28 198.666 63.574 198.27 63.898C197.814 64.27 197.478 64.594 197.262 64.87C197.046 65.134 196.938 65.458 196.938 65.842H194.562C194.562 65.314 194.646 64.858 194.814 64.474C194.994 64.078 195.204 63.754 195.444 63.502C195.684 63.238 195.996 62.944 196.38 62.62C196.812 62.26 197.124 61.954 197.316 61.702C197.52 61.45 197.622 61.144 197.622 60.784C197.622 60.352 197.472 60.028 197.172 59.812C196.872 59.584 196.506 59.47 196.074 59.47C195.618 59.47 195.12 59.596 194.58 59.848C194.052 60.1 193.548 60.454 193.068 60.91V58.39C193.992 57.598 195.066 57.202 196.29 57.202ZM194.004 68.47C194.004 67.942 194.172 67.516 194.508 67.192C194.844 66.856 195.276 66.688 195.804 66.688C196.356 66.688 196.806 66.856 197.154 67.192C197.502 67.516 197.676 67.942 197.676 68.47C197.676 68.986 197.502 69.406 197.154 69.73C196.806 70.054 196.356 70.216 195.804 70.216C195.276 70.216 194.844 70.054 194.508 69.73C194.172 69.406 194.004 68.986 194.004 68.47Z",
			fill: "#1D1D1D"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M309.919 96.7007C308.49 96.3178 307.717 95.0545 308.105 93.6072C308.478 92.216 309.842 91.4767 311.22 91.8458C312.597 92.2148 313.362 93.54 312.993 94.917C312.615 96.3277 311.325 97.0773 309.919 96.7007Z",
			fill: "#F385FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M306.768 76.7835C307.903 72.5473 313.053 71.1971 316.899 72.2275C320.788 73.2695 324.234 76.5556 323.089 80.8299C321.741 85.861 316.176 84.6119 313.825 89.1531C312.727 91.4726 309.278 90.4065 310.031 87.5955C311.467 82.2369 317.742 82.9135 318.612 79.6663C319.131 77.7293 317.81 76.1426 315.981 75.6526C313.502 74.9882 312.274 76.1448 310.971 78.1236C309.248 80.8873 306.205 78.8867 306.768 76.7835Z",
			fill: "#F385FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M160.193 141.997C159.466 143.286 158.05 143.72 156.745 142.985C155.49 142.277 155.114 140.772 155.814 139.529C156.514 138.287 157.988 137.876 159.23 138.576C160.502 139.293 160.907 140.729 160.193 141.997Z",
			fill: "#F385FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M140.118 140.094C136.297 137.94 136.271 132.616 138.226 129.148C140.202 125.641 144.242 123.12 148.097 125.293C152.635 127.85 150.041 132.93 153.854 136.336C155.828 137.976 153.937 141.052 151.402 139.623C146.569 136.899 148.785 130.99 145.857 129.339C144.11 128.354 142.244 129.239 141.315 130.889C140.054 133.125 140.869 134.602 142.462 136.356C144.71 138.712 142.015 141.163 140.118 140.094Z",
			fill: "#F385FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M341.103 108.147C338.876 105.92 338.796 102.768 341.051 100.513C343.219 98.3445 346.522 98.4338 348.669 100.581C350.816 102.727 350.815 105.985 348.669 108.131C346.471 110.329 343.294 110.338 341.103 108.147Z",
			fill: "#F385FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M356.495 68.0747C363.097 61.4728 374.029 64.4654 380.022 70.4588C386.083 76.5192 388.938 86.2458 382.277 92.907C374.436 100.748 365.506 92.5214 356.338 98.3919C351.845 101.5 346.621 95.8628 351.002 91.482C359.353 83.1307 370.202 91.0578 375.263 85.9972C378.281 82.9784 377.534 78.6467 374.684 75.7967C370.82 71.9321 367.325 72.7577 362.817 75.0195C356.699 78.2808 353.217 71.3524 356.495 68.0747Z",
			fill: "#F385FF"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter0_ddddd_12603_26629",
				x: 23.9412,
				y: 5.74265,
				width: 365.297,
				height: 452.461,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", {}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.0862745 0 0 0 0 0.188235 0 0 0 0 0.780392 0 0 0 0.05 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "BackgroundImageFix",
						result: "effect1_dropShadow_12603_26629"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", {
						dx: -2.72386,
						dy: 8.17157
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 10.2145 }),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.0862745 0 0 0 0 0.188235 0 0 0 0 0.780392 0 0 0 0.05 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "effect1_dropShadow_12603_26629",
						result: "effect2_dropShadow_12603_26629"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", {
						dx: -9.53349,
						dy: 35.4101
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 18.386 }),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.0862745 0 0 0 0 0.188235 0 0 0 0 0.780392 0 0 0 0.04 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "effect2_dropShadow_12603_26629",
						result: "effect3_dropShadow_12603_26629"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", {
						dx: -21.7908,
						dy: 78.9918
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 24.5147 }),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.0862745 0 0 0 0 0.188235 0 0 0 0 0.780392 0 0 0 0.03 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "effect3_dropShadow_12603_26629",
						result: "effect4_dropShadow_12603_26629"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", {
						dx: -39.4959,
						dy: 141.641
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 29.2814 }),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.0862745 0 0 0 0 0.188235 0 0 0 0 0.780392 0 0 0 0.01 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "effect4_dropShadow_12603_26629",
						result: "effect5_dropShadow_12603_26629"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "effect5_dropShadow_12603_26629",
						result: "shape"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter1_ddddd_12603_26629",
				x: .941204,
				y: 24.7426,
				width: 239.297,
				height: 282.091,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", {}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.0862745 0 0 0 0 0.188235 0 0 0 0 0.780392 0 0 0 0.05 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "BackgroundImageFix",
						result: "effect1_dropShadow_12603_26629"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", {
						dx: -2.72386,
						dy: 8.17157
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 10.2145 }),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.0862745 0 0 0 0 0.188235 0 0 0 0 0.780392 0 0 0 0.05 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "effect1_dropShadow_12603_26629",
						result: "effect2_dropShadow_12603_26629"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", {
						dx: -9.53349,
						dy: 35.4101
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 18.386 }),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.0862745 0 0 0 0 0.188235 0 0 0 0 0.780392 0 0 0 0.04 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "effect2_dropShadow_12603_26629",
						result: "effect3_dropShadow_12603_26629"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", {
						dx: -21.7908,
						dy: 78.9918
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 24.5147 }),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.0862745 0 0 0 0 0.188235 0 0 0 0 0.780392 0 0 0 0.03 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "effect3_dropShadow_12603_26629",
						result: "effect4_dropShadow_12603_26629"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", {
						dx: -39.4959,
						dy: 141.641
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 29.2814 }),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.0862745 0 0 0 0 0.188235 0 0 0 0 0.780392 0 0 0 0.01 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "effect4_dropShadow_12603_26629",
						result: "effect5_dropShadow_12603_26629"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "effect5_dropShadow_12603_26629",
						result: "shape"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint0_linear_12603_26629",
				x1: 285.633,
				y1: 290.976,
				x2: 189.747,
				y2: 221.974,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "white" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#D6DDF8"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint1_linear_12603_26629",
				x1: 125.561,
				y1: 186.867,
				x2: 215.022,
				y2: 274.21,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "white" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#D6DDF8"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint2_linear_12603_26629",
				x1: 198.675,
				y1: 290.976,
				x2: 294.562,
				y2: 221.974,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "white" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#D6DDF8"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint3_linear_12603_26629",
				x1: 358.747,
				y1: 186.867,
				x2: 269.287,
				y2: 274.21,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "white" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#D6DDF8"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint4_linear_12603_26629",
				x1: 346.829,
				y1: 249.881,
				x2: 247.471,
				y2: 178.379,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "white" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#D6DDF8"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint5_linear_12603_26629",
				x1: 203.889,
				y1: 36.9261,
				x2: 244.19,
				y2: 137.33,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "white" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#D6DDF8"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint6_linear_12603_26629",
				x1: 209.53,
				y1: 75.5322,
				x2: 294.344,
				y2: 223.018,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "white" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#D6DDF8"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint7_linear_12603_26629",
				x1: 215.68,
				y1: 65.8041,
				x2: 243.881,
				y2: 136.059,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#4222D0" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#070256"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint8_linear_12603_26629",
				x1: 126.166,
				y1: 118.762,
				x2: 342.557,
				y2: 330.031,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "white" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#D6DDF8"
				})]
			})
		] })
	]
});
export default SvgExploreNoResults;
